import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "../../utils/axiosConfig";
import "../../styles/features/events/Workshops.css";

export default function Workshops(){
  const navigate = useNavigate();
  const [upcoming, setUpcoming] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [loadingUpcoming, setLoadingUpcoming] = useState(true);

  useEffect(() => {
    let mounted = true;

    const loadUpcoming = async () => {
      try {
        setLoadingUpcoming(true);

        const responses = await Promise.allSettled(
          FEATURED_WORKSHOP_IDS.map((id) => axios.get(`/api/events/${id}`))
        );

        const items = responses
          .filter((r) => r.status === "fulfilled")
          .map((r) => r.value.data)
          .map(toWorkshopCard);

        if (mounted) setUpcoming(items);
      } catch (e) {
        console.error("Failed to load workshops:", e);
        if (mounted) setUpcoming([]);
      } finally {
        if (mounted) setLoadingUpcoming(false);
      }
    };

    loadUpcoming();

    // past na razie statycznie 
    setPastEvents(DEFAULT_PAST_WORKSHOPS);

    return () => {
      mounted = false;
    };
  }, []);

  const scrollToId = (id) => {
  const el = document.getElementById(id.replace(/^#/, ""));
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

  return (
      <div className="evs-page">  
      {/* HERO / INTRO */}
      <section className="evs section">
         <span className="evs__dot evs__dot--amber evs__dot--t1" aria-hidden="true" />
  <span className="evs__dot evs__dot--rose  evs__dot--t2" aria-hidden="true" />
        <div className="wrap grid two">
          <div>
            <h1 className="evs__title">Spotkaj się z dziewczynami przy kawie.<br/> Kreatywnie, swobodnie, bez spinki.</h1>
            <p className="evs__lead">Luźne spotkania w kobiecym gronie - pikniki, warsztaty i małe projekty DIY. Poznaj nowe przyjaciółki i przy okazji zrób coś fajnego przy filiżance dobrej kawy.</p>
           <div className="evs__cta">
          <button
            type="button"
            className="btn primary"
            onClick={() => scrollToId("#workshops-list")}
          >
            Zapisz się na warsztaty
          </button>

          <button
            type="button"
            className="btn description"
            onClick={() => scrollToId("#workshops-how")}
          >
            Jak to wygląda?
          </button>
        </div>
            <div className="evs__facts grid two">
              <Fact dot="var(--orange)" title="Kobiece grono" text="Bez ocen, w przyjaznej i swobodnej atmosferze." />
              <Fact dot="var(--orange)" title="Rozmowy przy kawie" text="Poznajesz osoby o podobnym vibe’ie i energii." />
              <Fact dot="var(--orange)" title="Kreatywne DIY" text="Malujemy, tworzymy i uczymy się razem — prosto i przyjemnie." />
              <Fact title="Nowe przyjaciółki" text="Prawdziwe rozmowy, realne znajomości." />
            </div>
          </div>
          <div>
            <img className="evs__hero-img-workshops evs__hero-img--party" src="/images/piknik2.jpg" alt="Workshop" />
                  <span className="evs__media-tab" aria-hidden="true" />
          </div>
          
        </div>
      </section>

<section id="workshops-how" className="section wrap">
        <span className="collage-dot"></span>

  <h2>Jak wyglądają nasze spotkania</h2>

  <div className="steps-wrap">
    <ol className="steps">
      <li>
        <div className="step-content">
          <strong className="step-title">Luźny start przy kawie</strong>
          <span className="step-desc">Szybka integracja – jak na spotkaniu z dawno niewidzianymi przyjaciółkami.</span>
        </div>
      </li>
      <li>
        <div className="step-content">
          <strong className="step-title">Część kreatywna (DIY)</strong>
          <span className="step-desc">Robimy coś twórczego - nie martw się, pokażemy Ci wszystko krok po kroku.</span>
        </div>
      </li>
      <li>
        <div className="step-content">
          <strong className="step-title">Chill & kontakty</strong>
          <span className="step-desc">Po warsztacie zostaje przestrzeń na rozmowy, śmiech i nawiązanie nowych znajomości.</span>
        </div>
      </li>
    </ol>

    {/* KOLRAŻ – nakładające się zdjęcia w stałym boksie */}
    <div className="steps-collage" aria-hidden="true">
      <img className="ph a" src="/images/pies.jpg" alt="" />
      <img className="ph b" src="/images/piknik-white.jpg" alt="" />
      <img className="ph c" src="/images/piknik3.jpg" alt="" />
      <img className="ph d" src="/images/piknik4.jpg" alt="" />
    </div>
  </div>

</section>




      {/* UPCOMING */}

    <section id="workshops-list" className="section band band--sand">
     
      <div className="section-head">
        <h2>Nadchodzące warsztaty</h2>
                                <p className="lead2">Żeby zapisać się na Warsztaty nie potrzebujesz zakładać konta</p>
      </div>
      <div className="upcoming-grid">
        {upcoming.map((ev) => (
          <article key={ev.eventId} className="event-card">
                <img src={ev.img} alt={ev.title} className="event-img" loading="lazy" />
            <div className="event-body">
              <h3 className="event-title">{ev.title}</h3>
              <div className="chips">
                <span className="chip">{ev.city}</span>
                <span className="chip">{ev.dateLabel}</span>
                {/* <span className="chip">{ev.godzina}</span> */}
              </div>
              <div className="event-actions">
                <span className="event-price">{ev.priceLabel}</span>
                    <button
                      className={`btn btn-primary ${ev.disabled ? "isDisabled" : ""}`}
                      disabled={ev.disabled}
                      onClick={() => {
                        if (ev.disabled) return;
                        navigate(`/events/${ev.eventId}`); // route do detali
                      }}
                    >
                      {ev.buttonLabel}
                    </button>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>

      {/* WAVE (odwrócona) + CROSS-SECTION BLOB: między JOIN a UPCOMING */}
      {/* <div className="wave-sep flip" aria-hidden="true">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none" className="wave-svg">
          <path d="M0,64 C120,96 240,128 360,128 C480,128 600,96 720,80 C840,64 960,64 1080,80 C1200,96 1320,128 1440,140 L1440,0 L0,0Z" />
        </svg>
      </div> */}
      
      {/* PAST (Za nami) */}
<section id="workshop-upcoming" className="section wrap">
  <div>
    <h2>Za nami (tak to wygląda w praktyce)</h2>
    <PastGrid events={pastEvents} />
  </div>
</section>



    </div>
  );
}

function toWorkshopCard(api) {
  const spotsLeft = api.spotsLeft ?? 0;
  const state = (api.signupState || "OPEN").toUpperCase();

  const noSpots = spotsLeft <= 0;
  const soon = state === "SOON";
  const closed = state === "CLOSED";

  const disabled = noSpots || soon || closed;

  let buttonLabel = "Zapisz się";
  if (noSpots) buttonLabel = "Brak miejsc";
  else if (soon) buttonLabel = "Zapisy wkrótce";
  else if (closed) buttonLabel = "Zapisy zakończone";

  return {
    eventId: api.id,
    title: api.title,
    city: api.city,
    img: api.images?.[0],
    dateLabel: api.date, // "2026-03-08" -> "8 marca 2026"
    priceLabel: api.price != null ? `${api.price} ${api.currency || "PLN"}` : "",
    accessType: api.accessType,
    disabled,
    buttonLabel,
    disabledReason: disabled ? buttonLabel : "",
  };
}

// --- helpers ---
function Fact({ badgeClass = "badge", dot, title, text }) {
  return (
    <div className="evs__fact">
      <span className={badgeClass}>
        <span className="b" style={dot ? { background: dot } : undefined} /> {title}
      </span>
      <br /><span className="muted">{text}</span>
    </div>
  );
}

function Step({ t, d }) {
  return (
    <div className="step">
      <div className="no" />
      <div><strong>{t}</strong><br /><span className="muted">{d}</span></div>
    </div>
  );
}

function Card({ city, title, meta, thumb, btn, href }) {
  return (
    <article className="card">
      <div className="thumb"><span>{thumb}</span></div>
      <div className="body">
        <div className="pill">{city}</div>
        <h3>{title}</h3>
        <div className="meta">{meta}</div>
        <a className="btn ghost" href={href}>{btn}</a>
      </div>
    </article>
  );
}


function PastGrid({ events = [] }) {
  return (
    <div className="pastgrid">
      {events.map((e) => (
        <PastCard key={e.id} {...e} />
      ))}
    </div>
  );
}

function PastCard({ id, title, excerpt, participants, location, coverUrl, href = "#" }) {
  return (
    <a className="pastcard" href={href} style={{ backgroundImage: `url(${coverUrl})` }} aria-label={title}>
      <div className="pastcard__overlay" />
      <div className="pastcard__content">
        <h3 className="pastcard__title">{title}</h3>
        {excerpt && <p className="pastcard__excerpt">{excerpt}</p>}
        <div className="pastcard__meta">
          <span className="pm">👥 {participants}</span>
          <span className="pm">📍 {location}</span>
        </div>
      </div>
    </a>
  );
}

// ---podmienic na API ---
const DEFAULT_UPCOMING_WORKSHOPS = [
  {
    id: 21,
    eventId: "EVT_SLB_2026",
    signupState: "OPEN",
    city: "Warszawa",
    title: "Self-Love Brunch – kobiecy brunch z mini sesjami zdjęciowymi",
    data: "kwiecień",
    img: "/imagesEvents/sesja.jpg"
  },
  {
    id: 22,
    eventId: "EVT_ARTCHILL_2026",
    signupState: "SOON",
    city: "Warszawa",
    title: "Art&Chill – kreatywny wieczór z malowaniem toreb",
    data: "maj",
    img: "/imagesEvents/bag.jpg"
  },
  {
    id: 23,
    eventId: "EVT_CANDLES_2026",
    signupState: "SOON",
    city: "Warszawa",
    title: "Warsztaty – zapachowe świece sojowe",
    data: "maj",
    img: "/imagesEvents/swiece.jpg"
  }
];

const FEATURED_WORKSHOP_IDS = [
  // "wor_bagp_2026_pic07bpm",
  // "wor_spf_2026_07fir",
  // "wor_szpp_2026_07stze8",
];

const DEFAULT_PAST_WORKSHOPS = [
  { id: "w1", title: "Piknik w parku: świece i rozmowy", excerpt: "Jesienny klimat, kocyk i nowe znajomości", participants: "10 osób", location: "Warszawa · Pole Mokotowskie", coverUrl: "/images/piknik4.jpg", href: "/photos" }
  // { id: "w2", title: "DIY zapachy do domu", excerpt: "Delikatne nuty i chill", participants: "9 osób", location: "Wrocław · Nadodrze", coverUrl: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=1200&auto=format&fit=crop", href: "/galeria/zapachy" },
  // { id: "w3", title: "Ramki z historią", excerpt: "Ręczne zdobienie + kawa", participants: "13 osób", location: "Gdańsk · Wrzeszcz", coverUrl: "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?q=80&w=1200&auto=format&fit=crop", href: "/galeria/ramki" },
  // { id: "w4", title: "Krąg rozmów: przyjaźnie od kawy", excerpt: "Małe kroki, wielkie rozmowy", participants: "10 osób", location: "Kraków · Podgórze", coverUrl: "https://images.unsplash.com/photo-1529101091764-c3526daf38fe?q=80&w=1200&auto=format&fit=crop", href: "/galeria/krag-kawy" },
];
